
// 健康档案 接口相关
import request from "../../untils/request.js"

/**
 * 
 *  get
 *  
 */

// 获取数据字典
export const getdict = (params) => {
    return request.get("/outpatient/index/dict", { params } )
}
// V2 查询患者经营分析总览
export const v2Patient = (params) => {
    return request.get("/outpatient/api/v2/patient/analytics/overview", { params } )
}


// 过敏信息表
export const aiseList = (params) => {
    return request.get("/outpatient/aise/list", { params } )
}

// 插入过敏信息(已有健康档案信息)
export const addPhrAlg = (data) => {
    return request.post("/outpatient/docphr/addPhrAlg", data )
}

// 删除过敏信息
export const deleteDocphr = (params) => {
    return request.get("/outpatient/docphr/delete", { params } )
}

// 添加居民健康档案人员关联关系
export const addRelationPhr = (params) => {
    return request.get("/outpatient/phr_relation/addRelationPhr", { params } )
}

// 删除居民健康档案人员关联关系
export const deleteRelation = (params) => {
    return request.delete("/outpatient/phr_relation/deleteRelation", { params } )
}

// 居民健康档案-信息
export const aiseDetails = (params) => {
     return request.get(`/outpatient/docphr/${params.id}`, { params: {} }) 
}

// 居民健康档案-信息
export const docphrList = (params) => {
     return request.get("/outpatient/docphr/list", { params } )
}

// 查询关联的健康档案人员信息
export const listRelation = (params) => {
    return request.get("/outpatient/phr_relation/listRelation", { params } )
}
/**
 * 
 *  post
 *  
 */

//新增健康档案
export const addDocphr = (data) => {
    return request.post("/outpatient/docphr", data )
}


/**
 * 
 *  put
 *  
 */

//修改健康档案
export const updateDocphr = (data) => {
    return request.put("/outpatient/docphr", data )
}

/**
 * 
 * DELETE 
 *  
 */   


// 暴露
export default{
	getdict,aiseList,aiseDetails,
	addDocphr,updateDocphr
}